import { render, staticRenderFns } from "./FeedCategoryEntry.vue?vue&type=template&id=71d36ca0&scoped=true&"
import script from "./FeedCategoryEntry.vue?vue&type=script&lang=ts&"
export * from "./FeedCategoryEntry.vue?vue&type=script&lang=ts&"
import style0 from "./FeedCategoryEntry.vue?vue&type=style&index=0&id=71d36ca0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d36ca0",
  null
  
)

export default component.exports